<template>
  <div v-if="selectedContract">
    <table class="table is-fullwidth is-striped is-hoverable">
      <thead>
        <tr>
          <th>Created At</th>
          <th>Amount</th>
          <th>Currency</th>
          <th>Description</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(payment, i) in payments" :key="i" @click="edit(invoice)">
          <td :title="formatDate(payment.created_at, { showRelative: false })">
            {{ formatDate(payment.created_at) }}
          </td>
          <td>
            <div class="control">
              <input
                style="width: unset"
                class="input"
                type="text"
                v-model="payments[i].amount"
              />
            </div>
          </td>
          <td>
            <div class="control">
              <input
                style="width: unset"
                class="input"
                type="text"
                v-model="payments[i].currency"
              />
            </div>
          </td>
          <td>
            <div class="control">
              <input
                style="width: unset"
                class="input"
                type="text"
                v-model="payments[i].description"
              />
            </div>
          </td>
          <td>
            <div class="control">
              <button class="button" @click="save(payments[i])">Save</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatDate } from "../../../../utils/date_converter";
import { httpInstance as http } from "@/plugins/http";
import toast from "@/utils/toast";

export default {
  name: "ContractPaymentsTab",
  props: {
    contractData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      payments: [],
      newPayment: Object,
    };
  },
  computed: {
    ...mapState(["selectedContract"]),
    contract() {
      return this.contractData || this.selectedContract;
    },
  },
  methods: {
    formatDate,
    getPayments() {
      if (!this.contract || !this.contract.id) return;
      http
        .get(`payments?page=1&size=20&contract_id=${this.contract.id}`)
        .then((response) => {
          this.payments = response.data.data;
        });
    },

    save(payment) {
      var formData = new FormData();
      formData.append("id", payment.id);
      formData.append("amount", payment.amount);
      formData.append("currency", payment.currency);
      formData.append("description", payment.description);

      http.patch("payments/", formData).then((response) => {
        if (response.status !== 200) {
          toast.error("Error occurred");
          return;
        }
        toast.success("Updated");
      });

      setTimeout(() => {
        this.getInvoices();
      }, 1000);
    },
  },
  mounted() {
    if (this.contract) {
      this.getPayments();
    }
  },
};
</script>

<style></style>
